import ImportProductThumbnailRequestModelBase from '../_generated/modelBases/import-product-thumbnail-request-model-base';

export default class ImportProductThumbnailRequestModel extends ImportProductThumbnailRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
